module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(_vm.todoList.length > 0) ? _c('div', {
    staticClass: "noted-grid"
  }, _vm._l((_vm.todoList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "grid-item"
    }, [_c('div', {
      staticClass: "item-index"
    }, [_c('div', {
      staticClass: "item-wrap"
    }, [_vm._v(_vm._s(item.id + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "item-title"
    }, [_c('div', {
      staticClass: "item-wrap"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "item-date"
    }, [_c('div', {
      staticClass: "item-wrap"
    }, [_vm._v(_vm._s(item.date))])]), _vm._v(" "), _c('div', {
      staticClass: "item-action"
    }, [_c('span', {
      on: {
        "click": function($event) {
          _vm.viewDetail(item)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          _vm.delNote(item)
        }
      }
    }, [_vm._v("删除")])])])
  })) : _vm._e(), _vm._v(" "), (_vm.todoList.length == 0) ? _c('div', {
    staticClass: "icon_no_list"
  }, [_vm._v("暂无记录")]) : _vm._e(), _vm._v(" "), (_vm.isShow) ? _c('detailDialog') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76461c36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/over.vue
// module id = 36
// module chunks = 0